import React from 'react'

import { Field } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Form, Col } from '_zari/core'

import * as TransaccionService from 'services/transaccion.service'

const ModeloCuentas12FormGroup = ({ iError, iTouched, fIsSubmitting, vCodigoTransaccion, setFieldValue, iValue }) => {
  const __adminContext = React.useContext(AdminContext)

  const [modelos, setModelos] = React.useState([])

  React.useEffect(() => {
    if (__adminContext.valoresConfiguracionUsuario.flagCambioCuenta12) {
      TransaccionService.obtenerxCodigoAsSelectModelosCuenta12(vCodigoTransaccion).then(({ data }) => {
        setModelos(data)
        if (data.length > 0 && !iValue) {
          setFieldValue('_idModeloCuentas12', data[0]._id)
        }
      })
    } else {
      TransaccionService.obtenerxCodigoAsSelectPrincipalModeloCuenta12(vCodigoTransaccion).then(({ data }) => {
        setModelos(data)
        if (data.length > 0 && !iValue) {
          setFieldValue('_idModeloCuentas12', data[0]._id)
        }
      })
    }
  }, [__adminContext, vCodigoTransaccion, setFieldValue, iValue])

  return (
    <Form.Group>
      <Form.Label text='CUENTA 12' htmlFor='select-modeloCuentas12' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idModeloCuentas12'>
          {({ field }) => (
            <Form.Select {...field} isInvalid={iTouched && iError} id='select-modeloCuentas12' disabled={modelos.length < 2 || fIsSubmitting}>
              {modelos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.descripcion}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ModeloCuentas12FormGroup)
